import React, { useState } from "react";
import { Box, Flex, Grid, Select, Text, css } from "@storyofams/react-ui";
import { usePostHog } from "posthog-js/react";
import { BlogCard } from "~components/common/BlogCard";
import { RecipeCard } from "~components/common/RecipeCard";

const sortOptions = [
  { label: "Populariteit", value: "rating", asc: true },
  { label: "Naam: A-Z", value: "title_text", asc: true },
  { label: "Naam: Z-A", value: "title_text", asc: false },
  { label: "Nieuw - Oud", value: "created_at", asc: false },
];

export const Recipes = ({ recipes, sorting, setSortingMemo }) => {
  const posthog = usePostHog();
  return (
    <>
      <Flex justifyContent={"space-between"} flexDirection={["column", "row"]}>
        <Text mb={3} fontFamily="DINPro" fontSize="28px" fontWeight="bold">
          Recepten met dit ingrediënt
        </Text>
        <Select
          mb={[1, 0]}
          zIndex={5}
          isSearchable={false}
          isDisabled={false}
          //@ts-ignore library restrictions
          onChange={(item) => setSortingMemo(item)}
          defaultValue={sorting}
          options={sortOptions}
          disableShadow
          minWidth={"183px"}
          css={css({
            "&.react-select": {
              fontSize: 2,
            },
            "& .react-select__control": {
              cursor: "pointer",
              minHeight: "38px",
              bg: "inherit",
              borderColor: "grey200",
              borderRadius: "md",
              svg: {
                fill: "grey800",
                stroke: "grey800",
              },
            },
            "& .react-select__option": {
              fontSize: 2,
              py: 0.5,
              "&:hover": {
                cursor: "pointer",
              },
            },
            // "& .react-select__option--is-selected": {
            //   bg: "grey400",
            // },
            "& .react-select__value-container": {
              pl: 1.5,
            },

            "& .react-select__indicator": {
              color: "grey800",
            },
          })}
        />
      </Flex>

      <Grid
        width="100%"
        rowGap={[1, 2, 5]}
        columnGap={[1.5]}
        rowSize={[1, 1, 3]}
      >
        {!!recipes &&
          recipes.map((item) => (
            <Box
              width={"100%"}
              maxWidth={["333px", "100%"]}
              key={item.id}
              // onClick={() =>
              //   posthog.capture("Clicked Product Page Menu", {
              //     subItem: "Recipe",
              //   })
              // }
            >
              <RecipeCard content={item} isShortCard />
            </Box>
          ))}
      </Grid>
    </>
  );
};
